(function() {
    'use strict';

    angular
        .module('c3WebApp')
        .controller('BrazilianCitizenDetailController', BrazilianCitizenDetailController);

    BrazilianCitizenDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BrazilianCitizen'];

    function BrazilianCitizenDetailController($scope, $rootScope, $stateParams, previousState, entity, BrazilianCitizen) {
        var vm = this;

        vm.brazilianCitizen = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('c3WebApp:brazilianCitizenUpdate', function(event, result) {
            vm.brazilianCitizen = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
